module.exports = __webpack_public_path__ + "static/media/Medical Referral service.ce29be0e.png";